"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeinSourceCommerce = exports.TradeinShippingEstimateResultCodeCommerce = exports.PricingAdjustmentStagingItemvalidationStatusEnumType = exports.PaymentPreferenceCommerce = exports.OmitMeasurementsOptionAdmin = exports.InventoryItemSortCommerce = exports.ColorHueEnumTypeAdmin = exports.CatalogItemMeasurementFieldPurposePublic = exports.CatalogItemMeasurementFieldPurposeCommerce = exports.CatalogItemMeasurementFieldPurposeAdmin = void 0;
var CatalogItemMeasurementFieldPurposeAdmin;
(function (CatalogItemMeasurementFieldPurposeAdmin) {
    /** Load all measurement fields configured for use by check-in associates when checking in new instances of this catalog item. */
    CatalogItemMeasurementFieldPurposeAdmin["Checkin"] = "CHECKIN";
    /** Load all configured measurement fields for this catalog item. */
    CatalogItemMeasurementFieldPurposeAdmin["General"] = "GENERAL";
    /** Load all measurement fields for this catalog item that are configured for display to customers. */
    CatalogItemMeasurementFieldPurposeAdmin["Shop"] = "SHOP";
})(CatalogItemMeasurementFieldPurposeAdmin || (exports.CatalogItemMeasurementFieldPurposeAdmin = CatalogItemMeasurementFieldPurposeAdmin = {}));
var CatalogItemMeasurementFieldPurposeCommerce;
(function (CatalogItemMeasurementFieldPurposeCommerce) {
    /** Load all measurement fields configured for use by check-in associates when checking in new instances of this catalog item. */
    CatalogItemMeasurementFieldPurposeCommerce["Checkin"] = "CHECKIN";
    /** Load all configured measurement fields for this catalog item. */
    CatalogItemMeasurementFieldPurposeCommerce["General"] = "GENERAL";
    /** Load all measurement fields for this catalog item that are configured for display to customers. */
    CatalogItemMeasurementFieldPurposeCommerce["Shop"] = "SHOP";
})(CatalogItemMeasurementFieldPurposeCommerce || (exports.CatalogItemMeasurementFieldPurposeCommerce = CatalogItemMeasurementFieldPurposeCommerce = {}));
var CatalogItemMeasurementFieldPurposePublic;
(function (CatalogItemMeasurementFieldPurposePublic) {
    /** Load all measurement fields configured for use by check-in associates when checking in new instances of this catalog item. */
    CatalogItemMeasurementFieldPurposePublic["Checkin"] = "CHECKIN";
    /** Load all configured measurement fields for this catalog item. */
    CatalogItemMeasurementFieldPurposePublic["General"] = "GENERAL";
    /** Load all measurement fields for this catalog item that are configured for display to customers. */
    CatalogItemMeasurementFieldPurposePublic["Shop"] = "SHOP";
})(CatalogItemMeasurementFieldPurposePublic || (exports.CatalogItemMeasurementFieldPurposePublic = CatalogItemMeasurementFieldPurposePublic = {}));
var ColorHueEnumTypeAdmin;
(function (ColorHueEnumTypeAdmin) {
    ColorHueEnumTypeAdmin["BluePurple"] = "BLUE_PURPLE";
    ColorHueEnumTypeAdmin["GreenYellow"] = "GREEN_YELLOW";
    ColorHueEnumTypeAdmin["Neutral"] = "NEUTRAL";
    ColorHueEnumTypeAdmin["Other"] = "OTHER";
    ColorHueEnumTypeAdmin["RedOrange"] = "RED_ORANGE";
})(ColorHueEnumTypeAdmin || (exports.ColorHueEnumTypeAdmin = ColorHueEnumTypeAdmin = {}));
var InventoryItemSortCommerce;
(function (InventoryItemSortCommerce) {
    /** Sort inventory items by when they first transitioned to FORSALE_APPROVED (ascending) */
    InventoryItemSortCommerce["AddedAtAscending"] = "ADDED_AT_ASCENDING";
    /** Sort inventory items by a shuffled order that changes roughly daily */
    InventoryItemSortCommerce["Shuffled"] = "SHUFFLED";
})(InventoryItemSortCommerce || (exports.InventoryItemSortCommerce = InventoryItemSortCommerce = {}));
var OmitMeasurementsOptionAdmin;
(function (OmitMeasurementsOptionAdmin) {
    /** Omit any auto-generated measurements text from the condition notes whether or not structured measurements collection is enabled for check-in. */
    OmitMeasurementsOptionAdmin["Always"] = "ALWAYS";
    /** Return the notes including any measurements text generated automatically at check-in time. */
    OmitMeasurementsOptionAdmin["Never"] = "NEVER";
    /** Omit any auto-generated measurements text from the condition notes provided structured measurements collection is enabled for check-in. */
    OmitMeasurementsOptionAdmin["WhenMeasurementsEnabledForCheckin"] = "WHEN_MEASUREMENTS_ENABLED_FOR_CHECKIN";
})(OmitMeasurementsOptionAdmin || (exports.OmitMeasurementsOptionAdmin = OmitMeasurementsOptionAdmin = {}));
/** Payment method preference for trade-in payout */
var PaymentPreferenceCommerce;
(function (PaymentPreferenceCommerce) {
    /** Payout via gift card */
    PaymentPreferenceCommerce["Giftcard"] = "GIFTCARD";
    /** Payout via bank transfer (IBAN) */
    PaymentPreferenceCommerce["Iban"] = "IBAN";
})(PaymentPreferenceCommerce || (exports.PaymentPreferenceCommerce = PaymentPreferenceCommerce = {}));
var PricingAdjustmentStagingItemvalidationStatusEnumType;
(function (PricingAdjustmentStagingItemvalidationStatusEnumType) {
    PricingAdjustmentStagingItemvalidationStatusEnumType["Error"] = "error";
    PricingAdjustmentStagingItemvalidationStatusEnumType["Valid"] = "valid";
    PricingAdjustmentStagingItemvalidationStatusEnumType["Warning"] = "warning";
})(PricingAdjustmentStagingItemvalidationStatusEnumType || (exports.PricingAdjustmentStagingItemvalidationStatusEnumType = PricingAdjustmentStagingItemvalidationStatusEnumType = {}));
var TradeinShippingEstimateResultCodeCommerce;
(function (TradeinShippingEstimateResultCodeCommerce) {
    /** A specific shipping estimate has not been provided b/c shipping will be calculated at checkout. */
    TradeinShippingEstimateResultCodeCommerce["CalculatedAtCheckout"] = "CALCULATED_AT_CHECKOUT";
})(TradeinShippingEstimateResultCodeCommerce || (exports.TradeinShippingEstimateResultCodeCommerce = TradeinShippingEstimateResultCodeCommerce = {}));
var TradeinSourceCommerce;
(function (TradeinSourceCommerce) {
    /** Indicates the trade-in was created externally, e.g., via a third-party integration or partner system. */
    TradeinSourceCommerce["External"] = "EXTERNAL";
    /** Indicates the trade-in was created internally. */
    TradeinSourceCommerce["Trove"] = "TROVE";
})(TradeinSourceCommerce || (exports.TradeinSourceCommerce = TradeinSourceCommerce = {}));
//# sourceMappingURL=rewareCommerceTypes.js.map